// coverage lives in the vision and press entry-point tests, which assert the share-image metadata built from it
export const ABOUT_OG_IMAGE = '/brand-pages/about/opengraph-about.jpg';
